import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';
import {FreeDataCartesianBuilder} from '../../core/parameters/FreeDataCartesianBuilder';

export class VisionCriteria extends BasicCriteria {
cartesian: FreeDataCartesianBuilder;
codeList: string[];
nameLike: string;
stepLevels: number[];
}

